import React, { memo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import InformationCard, { IInformationCardProps } from '../../../../../components/InformationCard/InformationCard';
import emailImage from '../../../../../assets/images/email.svg';
import { TRecipient } from '../../../../../store/users/users.types';

import useStyles from './shippingAddress.styles';

export interface IShippingEmailCardProps extends IInformationCardProps {
  recipient: TRecipient | null;
}

const ShippingEmailCard = ({ recipient, ...infoCardProps }: IShippingEmailCardProps) => {
  const classes = useStyles();
  const { palette } = useTheme();

  return (
    <Box maxWidth={[320, 430]} mx="auto">
      <InformationCard
        title="Email address"
        borderColor={palette.grey.timberWolf}
        minHeight={120}
        data-testid="shippingAddressDetails"
        {...infoCardProps}
      >
        <Box width={1} display="flex" justifyContent="flex-start" alignItems="center">
          <img className={classes.image} src={emailImage} alt="Meeting" />
          <Box textAlign="left" maxWidth={200}>
            <Typography className="Body-Regular-Left-Static">
              {recipient?.firstName}&nbsp;{recipient?.lastName}
            </Typography>
            <Typography className="Body-Regular-Left-Static-Bold">{recipient?.email}</Typography>
          </Box>
        </Box>
      </InformationCard>
    </Box>
  );
};

export default memo(ShippingEmailCard);
